<template>
  <div>
    <!-- eslint-disable-next-line -->
    <div v-for="dialog in $store.state.Dialog.confirmDialog">
      <v-dialog v-model="dialog.isConfirm" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ dialog.title }}</v-card-title>
          <v-card-text>{{ dialog.content }}</v-card-text>
          <v-card-actions>
            <v-spacer />
            <!-- eslint-disable-next-line -->
            <div v-for="button in customButtonsArray(dialog)">
              <v-btn :color="typeof button.color !== 'undefined' ? button.color : null" text @click="clickCustomButton(dialog, button)">{{
                button.text
              }}</v-btn>
            </div>
            <v-btn color="" text @click="$store.commit('CANCEL_DIALOG', dialog)" v-if="dialog.customButtons == null">{{ $t("global.cancel") }}</v-btn>
            <v-btn color="accent" text @click="$store.commit('ACCEPT_DIALOG', dialog)" v-if="dialog.customButtons == null">{{ $t("global.ok") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  methods: {
    customButtonsArray(dialog) {
      if (typeof dialog == "undefined" || dialog.customButtons == null) return [];
      return dialog.customButtons;
    },
    clickCustomButton(dialog, button) {
      dialog.result = button.value;
      this.$store.commit("ACCEPT_DIALOG", dialog);
    }
  }
};
</script>

<style scoped />
